import { P2GGrid, P2GBox, P2GText } from '@parcel2go/core-ui';

interface props {
  code: string;
  selectable: boolean;
  children?: React.ReactNode;
}

const TariffCode: React.FC<props> = (props) => {
  const code = (props.code || '').replaceAll(' ', '');

  const getNum = (i: number) => {
    return code[i] || '_';
  };

  const split = () => {
    const o = [];
    for (let index = 0; index < Math.max(6, code.length); index += 2) {
      o.push(`${getNum(index)}${getNum(index + 1)}`);
    }
    return o;
  };

  const renderItem = (text: string, index: number) => {
    let colour;
    switch (index) {
      case 0:
        colour = '#dbdceb';
        break;
      case 1:
        colour = '#cae2f0';
        break;
      default:
        colour = '#c9e8e5';
        break;
    }

    return (
      <P2GGrid item flexShrink={1}>
        <div style={{ opacity: text == '__' ? 0.3 : 1 }}>
          <P2GBox backgroundColour={colour} textAlign="center">
            <div style={{ width: '25px', padding: '5px 0' }}>
              <P2GText variant="body2">{text || <>&nbsp;</>}</P2GText>
            </div>
          </P2GBox>
        </div>
      </P2GGrid>
    );
  };

  return (
    <P2GGrid container wrap="nowrap" alignContent="center" alignItems="center" gap={1}>
      {split().map(renderItem)}
      {props.children && <P2GGrid item>{props.children}</P2GGrid>}
    </P2GGrid>
  );
};

export { TariffCode };
